import { json } from './api'

export type CancellationRequest = {
  id: string; account_id: string; subscription_id: string; withdrawal: boolean; reason: string
  created_at: string; effective_at: string; approved_at: string | null; reviewed_by_id: number | null
  review_reason: string; confirmed_at: string | null; completed_at: string | null; last_error: string
  support_ticket_id: string | null; support_protocol: string | null
}

export function approveCancellation(id: string, reason: string) {
  return json<CancellationRequest>(`/v1/accounts/legal/cancellations/${encodeURIComponent(id)}/approve/`, {
    method: 'POST', body: JSON.stringify({ reason }),
  })
}
